import { useCallback } from 'react';
export function useKeyboardEventHandler(clickHandler) {
  return useCallback(event => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      if (clickHandler) {
        clickHandler(event);
      }
    }
  }, [clickHandler]);
}